export const confirmActionModalTheme = {
  message: 'palette.tertiary.80',
  title: 'palette.tertiary.95',
};
